import { Action, createReducer, on } from '@ngrx/store';
import {
  removeCertificate,
  setCertificate,
} from './../actions/certificate.actions';
import { UserCertificate } from './../models/certificate.model';

export const initialState: UserCertificate | undefined = undefined;

export const certificateReducer = createReducer<
  UserCertificate | undefined,
  Action
>(
  initialState,
  on(setCertificate, (state, certificate) => {
    return { ...state, ...certificate };
  }),
  on(removeCertificate, (state, certificate) => {
    return Object.assign({}, initialState);
  })
);
